/**
 * @desc 红人管理-保存
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(body: defs.kol.CelebrityRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
